import { DefaultSelectProps, SelectInput } from '@frontend/basic-forms';
import { EntityType } from '@frontend/common';
import React from 'react';

const ID = 'group-type-select';
/**
 * @deprecated
 */
export const GroupTypeSelect = (props: DefaultSelectProps) => {
    const options = [EntityType.USER_GROUP, EntityType.EQUIPMENT_GROUP, EntityType.PRODUCT_GROUP, EntityType.PRODUCT_CATEGORY, EntityType.QUESTIONNAIRE];
    return (
        <SelectInput
            {...props}
            id={props.id || ID}
            isClearable={props.isClearable}
            label={props.label || 'Type'}
            options={options.map((c) => ({ value: c, label: c.toString() }))}
            value={props.value}
            submitted={props.submitted}
            onChange={props.onChange}
        />
    );
};
